import { Person, IPerson } from '@/classes/InjuryForm/Person';

interface IWitness extends IPerson {
    statement?: string;
    noWitness?: boolean;
}

class Witness extends Person implements IWitness {
    public statement?: string;
    public noWitness?: boolean;

    constructor(w: IWitness = {}) {
        super(w);
        this.statement = w.statement;
    }

    public isWitnessTabValid(): string[] {
        const validations: string[] = [];
        if (this.noWitness !== true) {
            if (this.firstName === undefined || this.firstName.length === 0) {
                validations.push('witnessFirstName');
            }
            if (this.lastName === undefined || this.lastName.length === 0) {
                validations.push('witnessLastName');
            }
            if (this.title === undefined || this.title.length === 0) {
                validations.push('witnessTitle');
            }
            if (this.statement === undefined || this.statement.length === 0) {
                validations.push('witnessStatement');
            }
        }
        return validations;
    }
}

export default Witness;
export { Witness, IWitness };
